export const ROUTE_CONSTANTS = {
  home: '',
  homepage: 'home',
  logout: 'logout',
  referenceData: {
    list: 'reference-data-list',
    prefix: 'reference-data-detail',
    edit: 'reference-data-detail/:id',
  },
  glStringMapping: {
    list: 'gl-string-mapping-list',
    prefix: 'gl-string-mapping-detail',
    edit: 'gl-string-mapping-detail/:id',
  },
  glStringLookupMappingSet: {
    list: 'gl-string-lookup-mapping-set-list',
    prefix: 'gl-string-lookup-mapping-set-detail',
    edit: 'gl-string-lookup-mapping-set-detail/:id',
  },
  glStringLookupMapping: {
    prefix: 'gl-string-lookup-mapping-detail',
    new: 'gl-string-lookup-mapping-set-detail/:setId/gl-string-lookup-mapping-detail',
    edit: 'gl-string-lookup-mapping-set-detail/:setId/gl-string-lookup-mapping-detail/:id'
  },
  setting: {
    list: 'setting-list',
    prefix: 'setting-detail',
    edit: 'setting-detail/:id',
  },
  user: {
    list: 'user-list',
    prefix: 'user-detail',
    edit: 'user-detail/:id'
  },
  organisation: {
    list: 'organisation-list',
    prefix: 'organisation-detail',
    edit: 'organisation-detail/:id',
  },
  careAllowanceApplication: {
    list: 'care-allowance-application-list',
    prefix: 'care-allowance-application',
  },
  careAllowanceLocalAdoption: {
    prefix: 'care-allowance-local-adoption',
    newViaPersonDetail: 'care-allowance-local-adoption/person/:personId/role/:roleId',
    view: 'care-allowance-local-adoption/:id',
    newWithMatchViaPersonList: 'care-allowance-local-adoption/person/:personId/role/:roleId/associatedPerson/:associatedPersonId',
    segments:
    {
      person: 'person',
      role: 'role',
      associatedPerson: 'associatedPerson',
      isFromClient: 'isFromClient'
    }
  },
  applicationDetailCreateUpdateCarer: {
    prefix: 'create-update-carer',
    view: 'care-allowance-application/create-update-carer/:id'
  },
  applicationDetailCreateUpdatePlacement: {
    prefix: 'create-update-placement',
    view: 'care-allowance-application/create-update-placement/:id'
  },
  concessionsApplication: {
    list: {
      prefix: 'concessions-application-list',
      myApplications: 'concessions-application-list/my-applications',
      pendingReview: 'concessions-application-list/pending-review',
      readyForApproval: 'concessions-application-list/ready-for-approval',
      myApplicationsSegment: 'my-applications'
    },
    prefix: 'concessions-application',
    forPerson: 'person',
    newForPerson: 'concessions-application/person/:personId',
  },
  concessionsApplicationNonMainsWater: {
    prefix: 'non-mains-water',
    new: 'concessions-application/non-mains-water',
    newForPerson: 'concessions-application/non-mains-water/person/:personId',
    edit: 'concessions-application/non-mains-water/:id'
  },
  concessionsApplicationNonMainsEnergy: {
    prefix: 'non-mains-energy',
    new: 'concessions-application/non-mains-energy',
    newForPerson: 'concessions-application/non-mains-energy/person/:personId',
    edit: 'concessions-application/non-mains-energy/:id'
  },
  concessionsApplicationNonMainsLifeSupport: {
    prefix: 'non-mains-life-support',
    new: 'concessions-application/non-mains-life-support',
    newForPerson: 'concessions-application/non-mains-life-support/person/:personId',
    edit: 'concessions-application/non-mains-life-support/:id'
  },
  concessionsApplicationNonMainsMedicalCooling: {
    prefix: 'non-mains-medical-cooling',
    new: 'concessions-application/non-mains-medical-cooling',
    newForPerson: 'concessions-application/non-mains-medical-cooling/person/:personId',
    edit: 'concessions-application/non-mains-medical-cooling/:id'
  },
  concessionsApplicationEdaAndPowGoldCardMunicipalRates: {
    prefix: 'eda-and-pow-gold-card-municipal-rates',
    new: 'concessions-application/eda-and-pow-gold-card-municipal-rates',
    newForPerson: 'concessions-application/eda-and-pow-gold-card-municipal-rates/person/:personId',
    edit: 'concessions-application/eda-and-pow-gold-card-municipal-rates/:id'
  },
  concessionsApplicationDetail: {
    prefix: 'details',
    view: 'concessions-application/details/:id',
    invoiceListPrefix: 'invoice-list',
    invoiceList: 'concessions-application/:id/invoice-list'
  },
  applicationDetailNonMainsWaterConcession: {
    prefix: 'non-mains-water-concession',
    view: 'application/non-mains-water-concession/:id'
  },
  concessionsApplicationRebateCalculationRule: {
    list: {
      prefix: 'concessions-application-rebate-calculation-rule-list',
      rebateRulesApproved: 'concessions-application-rebate-calculation-rule-list/approved',
      rebateRulesPendingApproval: 'concessions-application-rebate-calculation-rule-list/pending-approval'
    },
    prefix: 'concessions-rebate-calculation-rule',
    prefixViewPending: 'concessions-rebate-calculation-rule-view-pending',
    edit: 'concessions-rebate-calculation-rule/:id',
    viewPending: 'concessions-rebate-calculation-rule-view-pending/:id'
  },
  rule: {
    list: 'payment-rule-list',
    prefix: 'rule',
    edit: 'rule/:id',
  },
  careAllowancePlacementRule: {
    list: 'care-allowance-placement-rule-list',
    prefix: 'care-allowance-placement-rule',
    edit: 'care-allowance-placement-rule/:id'
  },
  careAllowanceYear: {
    generateInvoicePeriods: 'generate-invoice-periods',
  },
  careAllowanceFinancialYear: {
    list: 'care-allowance-financial-year-list',
    prefix: 'care-allowance-financial-year',
    edit: 'care-allowance-financial-year/:id',
    editWithInvoicePeriods: 'care-allowance-financial-year/:id/generate-invoice-periods'
  },
  careAllowanceCalendarYear: {
    list: 'care-allowance-calendar-year-list',
    prefix: 'care-allowance-calendar-year',
    edit: 'care-allowance-calendar-year/:id',
    editWithInvoicePeriods: 'care-allowance-calendar-year/:id/generate-invoice-periods'
  },
  careAllowanceInvoicePeriod: {
    prefix: 'care-allowance-invoice-period',
    edit: 'care-allowance-financial-year/:financialYearId/care-allowance-invoice-period/:id'
  },
  careAllowanceRate: {
    list: {
      prefix: 'care-allowance-rate-list',
      ratesApproved: 'care-allowance-rate-list/approved',
      ratesPendingApproval: 'care-allowance-rate-list/pending-approval'
    },
    prefix: 'care-allowance-rate',
    prefixViewPending: 'care-allowance-rate-view-pending',
    edit: 'care-allowance-rate/:id',
    viewPending: 'care-allowance-rate-view-pending/:id'
  },
  careAllowancePlacement: {
    list: 'care-allowance-placement-list',
    prefix: 'care-allowance-placement',
    view: 'care-allowance-placement-list/care-allowance-placement/:id',
    viewFromPerson: 'person-detail/:personId/care-allowance-placement/:id',
    viewFromApplication: 'care-allowance-application/create-update-placement/:applicationId/care-allowance-placement/:id'
  },
  careAllowancePlacementAdjustment: {
    prefix: 'adjustment',
    listPrefix: 'adjustment-list',
    listViaPlacementList: 'care-allowance-placement-list/care-allowance-placement/:placementId/adjustment-list',
    listViaPersonDetail: 'person-detail/:personId/care-allowance-placement/:placementId/adjustment-list',
    listViaPlacementDetail: 'care-allowance-application/create-update-placement/:applicationId/care-allowance-placement/:placementId/adjustment-list',
    newViaPlacementList: 'care-allowance-placement-list/care-allowance-placement/:placementId/adjustment-list/adjustment',
    newViaPersonDetail: 'person-detail/:personId/care-allowance-placement/:placementId/adjustment-list/adjustment',
    newViaPlacementDetail: 'care-allowance-application/create-update-placement/:applicationId/care-allowance-placement/:placementId/adjustment-list/adjustment',  
    viewViaPlacementList: 'care-allowance-placement-list/care-allowance-placement/:placementId/adjustment-list/adjustment/:id',
    viewViaPersonDetail: 'person-detail/:personId/care-allowance-placement/:placementId/adjustment-list/adjustment/:id',
    generateAdjustmentLines: 'generate-adjustment-lines',
    editWithGeneratedAdjustmentLinesViaPlacementList: 'care-allowance-placement-list/care-allowance-placement/:placementId/adjustment-list/adjustment/:totalLines/generate-adjustment-lines/:recoveryAmount',
    editWithGeneratedAdjustmentLinesViaPersonDetail: 'person-detail/:personId/care-allowance-placement/:placementId/adjustment-list/adjustment/:totalLines/generate-adjustment-lines/:recoveryAmount',
  },
  careAllowancePlacementInvoice: {
    listPrefix: 'care-allowance-invoice-list',
    list: 'care-allowance-invoice-list',
    listViaPlacementList: 'care-allowance-placement-list/care-allowance-placement/:placementId/care-allowance-invoice-list',
    listViaPersonDetail: 'person-detail/:personId/care-allowance-placement/:placementId/care-allowance-invoice-list',
    listViaPlacementDetail: 'care-allowance-application/create-update-placement/:applicationId/care-allowance-placement/:placementId/care-allowance-invoice-list',
  },
  iccmsRequestProcessingSchedule: {
    list: 'iccms-request-processing-schedule-list',
    prefix: 'iccms-request-processing-schedule',
    edit: 'iccms-request-processing-schedule/:id'
  },
  person: {
    list: 'person-list',
    prefixDetail: 'person-detail',
    viewDetail: 'person-detail/:id',
    viewDetailFromPlacementList: 'care-allowance-placement-list/person-detail/:id',
    updateCreateCarerApplicationPrefix: 'update-create-carer-application',
    updateCreateCarerApplication: 'person-list/update-create-carer-application/:id',
    updateCreateCarerApplicationViewPerson: 'person-detail/:id/update-create-carer-application/:applicationId',
    updateCreatePlacementApplicationPrefix: 'update-create-placement-application',
    updateCreatePlacementApplication: 'person-list/update-create-placement-application/:id',
    updateCreatePlacementApplicationViewPerson: 'person-detail/:id/update-create-placement-application/:applicationId',
    careAllowancePerson: {
      prefix: 'care-allowance-person',
      view: 'care-allowance-person/:id',
      edit: 'care-allowance-person/:id'
    },
    updateCreateLocalAdoptionPlacementPrefix: 'update-local-adoption-placement',
    updateCreateLocalAdoptionPlacement: 'person-list/update-local-adoption-placement/person/:personId/role/:roleId/isFromClient/:isFromClient',
  },
  vendor: {
    list: 'vendor-list',
    prefix: 'vendor',
    edit: 'vendor/:id'
  },
  errorLog: {
    list: 'error-log-list'
  },
  bankDetails: {
    prefix: 'bank-details',
    edit: 'bank-details/:personId'
  },
  vmgEmailTemplate: {
    new: 'vmg-email-template/:applicationId',
    prefix: 'vmg-email-template',
  },
  jobSchedule: {
    list: 'job-schedule-list',
    prefix: 'job-schedule',
    edit: 'job-schedule/:id'
  },
  job: {
    list: 'job-run-log-list'
  },
  exportedInvoice: {
    list: 'monitor-invoice-export-list',
    prefix: 'monitor-invoice-export',
    edit: 'monitor-invoice-export/:id'
  },
  concessionsApplicationBulkUpload: {
    prefix: 'concessions-application-bulk-upload'
  },
  errorLogBulkUploadList: {
    list: 'error-log-bulk-upload-list',
    prefix: 'error-log-bulk-upload-list',
    edit: 'error-log-bulk-upload-list/:id'
  },
  concessionsApplicationBulkUploadList: {
    list: 'concessions-application-bulk-upload-list'
  },
  reportList: {
    list: 'report-list'
  },
  agency: {
    list: 'agency-list',
    prefix: 'agency',
    edit: 'agency/:id'
  },
  concessionsApplicationBulkUploadDetail: {
    prefix: 'concessions-application-bulk-upload-detail',
    viewDetail: 'concessions-application-bulk-upload-detail/:id',
  },
  careAllowancePlacementBulkAdHocInvoiceQuery: {
    prefix: 'care-allowance-placement-bulk-ad-hoc-invoice-query',
    list: 'care-allowance-placement-bulk-ad-hoc-invoice-query-list',
    edit: 'care-allowance-placement-bulk-ad-hoc-invoice-query/:id',
    viewQuery: 'care-allowance-placement-bulk-ad-hoc-invoice-query-view/:id',
    prefixViewQuery: 'care-allowance-placement-bulk-ad-hoc-invoice-query-view'
  },
  vptasApplication: {
    list: {
      prefix: 'vptas-application-list',
      myApplications: 'vptas-application-list/my-applications',
      pendingReview: 'vptas-application-list/pending-review',
      readyForApproval: 'vptas-application-list/ready-for-approval',
      myApplicationsSegment: 'my-applications'
    },
    prefix: 'vptas-application',
    view: 'vptas-application/:id',
    details: {
      prefix: 'details',
      view: 'vptas-application/details/:id',
      invoiceListPrefix: 'invoice-list',
      invoiceList: 'vptas-application/:id/invoice-list',
      invoiceListByContact: 'vptas-application/contact/:contactId/invoice-list',
      subsidies: 'vptas-application/:id/subsidies',
      subsidyNew: 'vptas-application/:id/subsidy',
      subsidyEdit: 'vptas-application/:id/subsidy/:subsidyId',
      tripList: 'vptas-application/:id/trip-list'
    }
  },
  victorianPatientTransportAssistanceSchemePreApplicationQuestionnaire: {
    prefix: 'vptas-pre-application-questionnaire',
    edit: 'vptas-pre-application-questionnaire/:id',
  },
  victorianPatientTransportAssistanceSchemePreApplicationRebateCalculationRate: {
    list: {
      prefix: 'victorian-patient-transport-assistance-scheme-application-rebate-calculation-rate-list',
      rebateRatesApproved: 'victorian-patient-transport-assistance-scheme-application-rebate-calculation-rate-list/approved',
      rebateRatesPendingApproval: 'victorian-patient-transport-assistance-scheme-application-rebate-calculation-rate-list/pending-approval'
    },
    prefix: 'victorian-patient-transport-assistance-scheme-rebate-calculation-rule',
    prefixViewPending: 'victorian-patient-transport-assistance-scheme-rebate-calculation-rule-view-pending',
    edit: 'victorian-patient-transport-assistance-scheme-rebate-calculation-rule/:id',
    viewPending: 'victorian-patient-transport-assistance-scheme-rebate-calculation-rule-view-pending/:id'
  },
  victorianPatientTransportAssistanceSchemeApplication: {
    prefix: 'victorian-patient-transport-assistance-scheme-application',
    edit: 'victorian-patient-transport-assistance-scheme-application/:id',
    new: 'victorian-patient-transport-assistance-scheme-application',
    newForPerson: 'victorian-patient-transport-assistance-scheme-application/person/:personId'
  },
  victorianPatientTransportAssistanceSchemeApplicationList: {
    list: 'vptas-application-list'
  },
  victorianPatientTransportAssistanceSchemeNominatedPatientDetails: {
    prefix: 'victorian-patient-transport-assistance-scheme/nominated-patient-details',
    edit: 'victorian-patient-transport-assistance-scheme/nominated-patient-details/:id'
  },
  VptasSpecialist: {
    prefix: 'vptas-specialist',
    list: 'vptas-specialist-list',
    new: 'vptas-specialist',
    edit: 'vptas-specialist/:id',
  },
  VptasSpecialistProviderInformation: {
    prefix: 'vptas-specialist-provider-information',
    specialist: 'specialist',
    new: 'vptas-specialist-provider-information/specialist/:specialistId',
    edit: 'vptas-specialist-provider-information/specialist/:specialistId/:id',
  },
  VptasLga: {
    prefix: 'vptas-lga',
    list: 'vptas-lga-list',
    new: 'vptas-lga',
    edit: 'vptas-lga/:id',
  },
  vptasAdjustmentApplication: {
    prefix: 'vptas-adjustment-application',
    new: ':parentApplicationId/vptas-adjustment-application',
    viewAndedit: 'vptas-adjustment-application/:id'
  }
};
